<template>
	<div>
		<Headers
			title="TFT資源平台"
			subtitle="資源申請"/>

		<div class="container">
			<div class="content">
					<loading 
						:active.sync="isLoading" 
						:is-full-page="fullPageLoading">
					</loading>

					<!--篩選器-->
					<div class="main" :class="{ center: isMobile }">
						<span class="filter-button">資源種類</span>
						<base-dropdown>
							<base-button 
								size="sm" 
								slot="title" 
								type="secondary" 
								class="dropdown-toggle">
								{{ selectdCategory }}
							</base-button>
							<a v-for="(option,index) in categories" :key="index"
								@click="selectOption('種類', option)"  
								class="dropdown-item">
								{{ option }}
							</a>
						</base-dropdown>

						<span class="filter-button">申請資格</span>
						<base-dropdown>
							<base-button 
								size="sm" 
								slot="title" 
								type="secondary" 
								class="dropdown-toggle">
								{{ selectdQualify }}
							</base-button>
							<a v-for="(option,index) in qualify" :key="index"
								@click="selectOption('資格', option)"  
								class="dropdown-item">
								{{ option }}
							</a>
						</base-dropdown>
					</div>

						<!-- 資源卡片 -->
					<div v-for="(item,index) in resource" :key="index">
						<card v-show="item['published'] &&
							(selectdCategory == item.category || selectdCategory == '全部') &&
							(item.qualifications.includes(selectdQualify)|| selectdQualify == '全部')"
							:ref="item.title"
							:autoOpen="hashTag==item.title">
							<!-- 標題 -->
							<template>
								<template slot="title">
										<span class="item-title">【</span>{{item.category}}<span>】</span>{{item.title}} ({{item.distributionPolicy}})
								</template>

								<span slot="subtitleApplyDeadline" v-if="item.applyDeadline" :class="{ mobileSize: isMobile }">
										申請截止: {{ item.applyDeadline }} 
								</span>
								<span slot="subtitleAnnounceDeadline" v-if="item.announceDeadline" :class="{ mobileSize: isMobile }">
										公布結果: {{ item.announceDeadline }} 
								</span>
								<span slot="subtitleNumber" v-if="item.number" :class="{ mobileSize: isMobile }" >
										剩餘數量: {{ item.number }}
								</span>
	
								<template slot="tag">
										<base-button 
												:size="isMobile ? 'mini' : 'sm' " 
												v-for="(tag,index) in item.qualifications"                                    
												:key="index" >
														{{tag}}
										</base-button>
								</template>  
							</template>

							<!-- 展開細節 -->
							<template>
								<template slot="white">
									<cardRow>
											<h5>資源介紹</h5>
									</cardRow>  
									<cardRow v-if="item.supplier">提供者｜<br>
											<p v-html="item.supplier"></p>
									</cardRow>  
									<cardRow v-if="item.source">資源來歷｜<br>
											<p v-html="item.source"></p>
									</cardRow>    
									<cardRow v-if="item.description">資源內容｜<br>
											<p v-html="item.description"></p>
									</cardRow>
									<cardRow 
											v-if="item.attachedMission">附帶任務｜<br>
											<p v-html="item.attachedMission"></p>
									</cardRow> 
									<cardRow v-if="item.referenceLink">參考連結｜<br>
											<a v-bind:href="item.referenceLink" target="_blank">{{item.referenceLinkName}}</a>
									</cardRow>
									<cardRow v-if="item.referenceLink2">
											<a v-bind:href="item.referenceLink2" target="_blank">{{item.referenceLinkName2}}</a>
									</cardRow>
									<cardRow v-if="item.referenceLink3">
											<a v-bind:href="item.referenceLink3" target="_blank">{{item.referenceLinkName3}}</a>
									</cardRow>
								</template>
	
								<template slot="gray">
										<cardRow>
											<h5>申請方式</h5>
										</cardRow>  
										<cardRow>申請方式｜<br>		
											<p v-if="item.applyWay.includes('寄信')"> 
												{{ item.applyWay }}
												{{ item.applyLink }}
											</p>
											<p v-else>
												<a v-bind:href="item.applyLink" target="_blank">填表</a>即可
											</p>
										</cardRow> 
										<cardRow v-if="item.applyMission">注意事項｜<br>
											<p v-html="item.applyMission"></p>
										</cardRow>
										<cardRow v-if="item.applyNote1">申請備註一｜<br>
											<p v-html="item.applyNote1"></p>
										</cardRow>
										<cardRow v-if="item.applyNote2">申請備註二｜<br>
											<p v-html="item.applyNote2"></p>
										</cardRow>
								</template>
							</template>
						</card>  
					</div>  
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Papa from 'papaparse' // Google sheet 表單抓取


import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import Headers from "@/layout/Headers";
import card from "@/components/apply/card.vue";
import cardRow from "@/components/apply/cardRow.vue";

import resourceSheetURL_map from "@/config/resource-sheet-url-map"

export default {
  name: "home",
  components: {
		Loading,
		Headers,
		card,
		cardRow
  },

  data() {
    return {
			isLoading: true,
			fullPageLoading: true,
			hashTag: decodeURIComponent(this.$route.hash.slice(2)),
			selectdCategory:'全部',
			selectdQualify:'全部',
			categories: ['全部','物資','經費','課程企劃','專業協助','其他'],
			qualify: ['全部','第一年老師','第二年老師','校友','學校','後勤'],
			resource:[]
    }
  },

  methods: {
	  // 跳到特定的區塊
    goToPageSection(){ 
			var element = this.$refs[this.hashTag];
			var top = element[0].$el.offsetTop;
			window.scrollTo(0, top);
		},

		selectOption(target,selected){
			this.isLoading = true;
			if(target == '資格'){
				this.selectdQualify = selected
			} else if(target =='種類'){
				this.selectdCategory = selected
			}
			setTimeout((()=> { this.isLoading = false }),500);
		},

		filterEmptyData(resources){
			function notEmptyData(data){
				return data['資源類型'] && data['名稱']
			}
			const result = resources.filter(notEmptyData)
			return result
		},

		// 獲取 google sheet data
		getSheetData(url){
			return new Promise((reslove,reject)=>{
				Papa.parse( 
					url,
					{ 
						download: true,
						header: true,
						complete: (results) => {
							if(results.data){
								const result = this.filterEmptyData(results.data)
								reslove(result)
							} else {
								reject(results.errors)
							}
						},
					}
				)
			})
		},

		// 解析資料為指定格式
    dataParser(arr) {  
			return arr.map((item, _)=> {
				return { 
					category: item['資源類型'],
					title: item['名稱'],
					qualifications: item['申請資格'].split("/"),
					applyDeadline: item['申請期限'],
					announceDeadline: item['預計結果通知日期'],
					distributionPolicy: item['分配原則'],
					number: item['剩餘數量'],
					supplier: item['提供者'],
					source: item['資源來歷'].replace(/\n/g,'<br/>'),
					description: item['描述'].replace(/\n/g,'<br/>'),
					attachedMission: item['附帶任務'].replace(/\n/g,'<br/>'),
					referenceLink:item['參考連結'],
					referenceLinkName: item['參考連結名稱'],
					referenceLink2: item['參考連結2(optional)'],
					referenceLinkName2: item['參考連結名稱2(optional)'],
					referenceLink3: item['參考連結3(optional)'],
					referenceLinkName3: item['參考連結名稱3(optional)'],
					applyWay: item['申請方式'],
					applyLink: item['表單連結'],
					applyMission: item['申請注意事項'].replace(/\n/g,'<br/>'),
					published: item['是否確認發佈'] == "TRUE",
					applyNote1: item['申請備註一'],
					applyNote2: item['申請備註二'],
				} 
			}).sort(this.compareByDeadline);
		},

		// 比較申請截止日期
		compareByDeadline(a, b) {
			const datePattern = /^\d{4}\/\d{1,2}\/\d{1,2}$/;
			const aValid = datePattern.test(a.applyDeadline);
			const bValid = datePattern.test(b.applyDeadline);

			if (aValid && bValid) {
				return new Date(a.applyDeadline).getTime() - new Date(b.applyDeadline).getTime();
			} else if (aValid) {
				return -1;
			} else if (bValid) {
				return 1;
			} else {
				return 0;
			}
		},

		// 獲取所有 sheet 的資料
		async getAllSheetData(){
			const promises = [];
			['OD資源','HR資源','AD資源','TS資源','ER資源'].forEach(sheetName => {
				promises.push(this.getSheetData(resourceSheetURL_map[sheetName]))
			});
			const resources = await Promise.all(promises)

			let result = []
			resources.forEach(resource=>{
				result = result.concat(this.dataParser(resource))
			})
		
			return result
		},
  },

  created: async function() {
		this.resource = await this.getAllSheetData()
		this.isLoading = false
    this.$nextTick(() => {
        this.goToPageSection()
    })
  },

  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile
    }),		
  },

}
</script>

<style lang="scss">

.container{
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.content{
	width: 90%;
	min-height: 440px;
	padding: 10px 0px; 
}


.main {
  margin-top: 30px;
}

.filter-button {
	line-height: 43px;
	margin-right: 10px;
	font-size: 14px;
}

.item-title {
  margin-left: -6px;
}

.card_header_3Ufej .card_subtitle_2jVu4.card_mobileSubtitle_1Hz4N .mobileSize {
  font-size: 13px;
}

.center {
  text-align: center;
}
</style>
